const MAX_NAMES = 3

/**
 * Which names a short list shows, and how many are left for a count. Up to
 * three are all shown. A longer list shows the first two, so the count always
 * stands for at least two names rather than for one that would have fitted.
 */
export function shortenNames(names: string[]): { shown: string[], hiddenCount: number } {
  const shown = names.length > MAX_NAMES ? names.slice(0, MAX_NAMES - 1) : names

  return { shown, hiddenCount: names.length - shown.length }
}
